import { classNames } from 'primereact/utils';
import { useEffect } from 'react';
import { useCreateOrUpdateTicketMutation } from '../../../api/TicketAPI';
import { ITicket } from '../../../types/Types';
import { formatToEuroDateTime } from '../../../util/DateUtils';
import styles from './ticketCard.module.scss';

export type TicketCardProps = {
    ticket: ITicket,
    refresh: () => void
}

const TicketCard = (props: TicketCardProps) => {

    //const navigate = useNavigate();
    const [updateTicketAPI] = useCreateOrUpdateTicketMutation();

    const submit = async (status: string) => {

        updateTicketAPI({
            uid: props.ticket.uid,
            kurzbeschreibung: props.ticket.kurzbeschreibung,
            langbeschreibung: props.ticket.langbeschreibung,
            reporter: props.ticket.reporter,
            status: status,
        })
            .then(() => {
                props.refresh();
            })
            .catch((e) => alert("" + e));
    }

    useEffect(() => {

    }, []);

    return (

        <div className={classNames(styles.auftragCard)}>
            <div style={{ padding: '10px' }}>

                <div>
                    <h4 className={classNames(styles.advertisementCardHeader)}>TICKET-{props.ticket.id}: {props.ticket.kurzbeschreibung}</h4>
                </div>

                <div className="card" style={{ padding: "20px" }}>
                    <ul style={{ listStyleType: 'none' }}>

                        <li>{props.ticket.langbeschreibung}</li>
                        <li>Reporter: {props.ticket.reporter}</li>
                        <li>Status: {props.ticket.status}</li>
                        <li>Erstellt am: {formatToEuroDateTime(props.ticket.erstelltAm)}</li>

                    </ul>

                </div>
                <div>
                    <button className="btn btn-warning" onClick={() => submit("OFFEN")}>offen</button>
                    <button className="btn btn-primary" onClick={() => submit("IN_BEARBEITUNG")}>in bearbeitung</button>
                    <button className="btn btn-light" onClick={() => submit("IN_ABNAHME")}>in abnahme</button>
                    <button className="btn btn-success" onClick={() => submit("FERTIG")}>fertig</button>
                </div>
            </div>
        </div>
    );
}

export default TicketCard;

